/**
 * return timestamp of 12AM UTC time of the given date
 */
export const truncateDateToUTC12AMTime = (date: Date): number => {
    return Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
};
